<ng-template #descTemplate>
  <span class="text-muted">
      <span *ngIf="mdRepresentation.allMetadata(['person.jobTitle']).length > 0"
            class="item-list-job-title">
              <span *ngFor="let value of mdRepresentation.allMetadataValues(['person.jobTitle']); let last=last;">
                  <span [innerHTML]="value"></span><span *ngIf="!last">; </span>
              </span>
      </span>
  </span>
</ng-template>
<ds-truncatable [id]="mdRepresentation.id">
  <a [routerLink]="[itemPageRoute]"
     [innerHTML]="mdRepresentation.getValue()"
     [ngbTooltip]="mdRepresentation.allMetadata(['person.jobTitle']).length > 0 ? descTemplate : null"></a>
  <ds-orcid-badge-and-tooltip class="ml-1"
                              *ngIf="mdRepresentation.firstMetadata('person.identifier.orcid')"
                              [orcid]="mdRepresentation.firstMetadata('person.identifier.orcid')"
                              [authenticatedTimestamp]="mdRepresentation.firstMetadata('dspace.orcid.authenticated')">
  </ds-orcid-badge-and-tooltip>
</ds-truncatable>
